/**!
 * Copyright (c) 2021 Vertex Software LLC. All rights reserved.
 */
import { r as registerInstance, h, H as Host, g as getElement } from './index-8d7400a7.js';

const viewerLayerCss = ":host{pointer-events:none;overflow:hidden}:host(:not([stretch-off])){position:absolute;left:0;right:0;top:0;bottom:0}";

const ViewerLayer = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    /**
     * Indicates if the layer should stretch to fill the size of its container's
     * nearest positioned parent.
     */
    this.stretchOff = false;
  }
  /**
   * @ignore
   */
  render() {
    return (h(Host, null, h("slot", null)));
  }
  get hostEl() { return getElement(this); }
};
ViewerLayer.style = viewerLayerCss;

export { ViewerLayer as vertex_viewer_layer };
